// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__717ZX","educatorInfo":"styles_educatorInfo__18AN_"};